import { injectReducer } from 'store/reducers'

export default (store) => ({
  path: 'team/:teamId/members/upload',
  /*  Async getComponent is only invoked when route matches   */
  getComponent (nextState, cb) {
    /*  Webpack - use 'require.ensure' to create a split point
        and embed an async module loader (jsonp) when bundling   */
    require.ensure([
      './containers/MemberUploadContainer',
      './modules/memberUpload'
    ], (require) => {
      /*  Webpack - use require callback to define
          dependencies for bundling   */
      const MemberUpload = require('./containers/MemberUploadContainer').default
      const actions = require('./modules/memberUpload')
      const reducer = require('./modules/memberUpload').default

      /*  Add the reducer to the store on key named below*/
      injectReducer(store, { key: 'memberUpload', reducer: reducer })

      store.dispatch(actions.initialize())
      store.dispatch(actions.fetchData(nextState.params.teamId))

      /*  Return getComponent   */
      cb(null, MemberUpload)

    /* Webpack named bundle   */
    }, 'memberUpload')
  }
})



// WEBPACK FOOTER //
// ./src/routes/MemberUpload/index.js